import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import baseurl, { db_url } from '../../Api/BaseUrl';

export const Faceboockconnect = () => {
  const [pages, setPages] = useState([]); // تخزين الصفحات
  const [selectedPage, setSelectedPage] = useState(''); // الصفحة المختارة
  const [forms, setForms] = useState([]); // تخزين نماذج الـ Leads
  const [selectedForm, setSelectedForm] = useState(''); // النموذج المختار
  const [leads, setLeads] = useState([]); // تخزين بيانات الـ Leads

  useEffect(() => {
    // تحميل SDK فقط إذا لم يكن محمّلًا مسبقًا
    if (!window.FB) {
      const script = document.createElement('script');
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        console.log('Facebook SDK Loaded'); // تأكيد تحميل SDK
        window.FB.init({
          appId: '2398768517123822', // استبدل بالـ App ID الصحيح
          cookie: true,
          xfbml: true,
          version: 'v18.0',
        });
        console.log('Facebook SDK Initialized'); // تأكيد التهيئة
      };
      document.body.appendChild(script);
    } else {
      console.log('Facebook SDK already loaded');
      window.FB.init({
        appId: '2398768517123822',
        cookie: true,
        xfbml: true,
        version: 'v18.0',
      });
    }
  }, []);

  // إرسال بيانات المستخدم للباك اند
  const sendToBackend = async (accessToken, userID) => {
    try {
      const response = await fetch(`${db_url}api/v1/webhook`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accessToken, userID }),
      });

      const result = await response.json();
      console.log('✅ Data sent to backend:', result);
    } catch (error) {
      console.error('❌ Error sending data to backend:', error);
    }
  };

  // جلب قائمة الصفحات الخاصة بالمستخدم
  const fetchUserPages = (accessToken) => {
    fetch(`https://graph.facebook.com/me/accounts?access_token=${accessToken}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('📄 Raw Pages Response:', data); // لفحص الهيكل الكامل
        if (data.error) {
          console.error('❌ Error fetching pages:', data.error);
        } else {
          console.log('📄 User Pages:', data.data);
          setPages(data.data || []); // تحديث الحالة بالصفحات
        }
      })
      .catch((error) => console.error('❌ Fetch error:', error));
  };

  // جلب نماذج الـ Leads الخاصة بالصفحة المختارة
  const fetchLeadForms = (pageId, pageAccessToken) => {
    fetch(`https://graph.facebook.com/${pageId}/leadgen_forms?access_token=${pageAccessToken}`)
      .then((response) => response.json())
      .then((data) => {
        console.log('📑 Raw Forms Response:', data); // لفحص الهيكل الكامل
        if (data.error) {
          console.error('❌ No lead forms found:', data.error);
          setForms([]); // إعادة تعيين النماذج
        } else {
          console.log('📑 Lead Forms:', data.data);
          setForms(data.data || []); // تحديث النماذج
        }
      })
      .catch((error) => console.error('❌ Fetch error:', error));
  };

  // جلب بيانات الـ Leads الخاصة بالنموذج المختار
  const fetchLeads = async (formId, pageAccessToken) => {
    try {
      const response = await fetch(
        `https://graph.facebook.com/${formId}/leads?access_token=${pageAccessToken}`,
      );
      const data = await response.json();

      console.log('📥 RAW Leads Response:', JSON.stringify(data, null, 2)); // هذا سيبين الهيكل الحقيقي

      if (data.error) {
        console.error('❌ Facebook API Error:', data.error);
        if (data.error.code === 190) {
          console.error('⚠️ Token expired or invalid');
        }
        setLeads([]);
        return;
      }

      if (!data.data || data.data.length === 0) {
        console.log('ℹ️ No leads found for this form');
        setLeads([]);
        return;
      }

      // عرض أول عنصر لفحص الهيكل
      console.log('🔍 First Lead Sample:', JSON.stringify(data.data[0], null, 2));

      setLeads(data.data || []);
    } catch (error) {
      console.error('❌ Fetch error:', error);
      setLeads([]);
    }
  };

  // دالة محسنة لاستخراج البيانات من الهيكل المختلف
  const extractLeadData = (lead) => {
    console.log('🔍 Single Lead Structure:', JSON.stringify(lead, null, 2));

    const fieldData = lead.field_data || [];

    // قائمة بجميع الأسماء المحتملة للحقول
    const possibleFieldNames = {
      name: ['full_name', 'FULL_NAME', 'name', 'Name', 'first_name', 'last_name', 'Full Name'],
      email: ['email', 'EMAIL', 'Email', 'email_address', 'E-mail'],
      phone: ['phone', 'PHONE', 'Phone', 'phone_number', 'mobile', 'telephone', 'phoneNumber'],
    };

    // دالة مساعدة للبحث في field_data
    const findFieldValue = (names) => {
      for (let name of names) {
        const field = fieldData.find((f) => {
          // مقارنة بعدة طرق
          return (
            f.name === name ||
            f.name?.toLowerCase() === name.toLowerCase() ||
            f.name?.replace(/_/g, ' ') === name ||
            f.name?.replace(/_/g, ' ')?.toLowerCase() === name.toLowerCase()
          );
        });

        if (field?.values?.[0]) {
          console.log(`✅ Found ${name}:`, field.values[0]);
          return field.values[0];
        }
      }

      // إذا لم نجد في field_data، نجرب في fields مباشرة (إذا موجود)
      if (lead.fields) {
        for (let name of names) {
          if (lead.fields[name] || lead.fields[name.toLowerCase()]) {
            const value = lead.fields[name] || lead.fields[name.toLowerCase()];
            console.log(`✅ Found in fields ${name}:`, value);
            return value;
          }
        }
      }

      console.log(`❌ Not found for names:`, names);
      return 'N/A';
    };

    return {
      name: findFieldValue(possibleFieldNames.name),
      email: findFieldValue(possibleFieldNames.email),
      phone: findFieldValue(possibleFieldNames.phone),
      // إضافة حقول إضافية للمساعدة في debugging
      rawFieldData: fieldData,
    };
  };

  // تسجيل الدخول عبر فيسبوك
  const handleLogin = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          console.log('✅ User logged in:', response);
          const { accessToken, userID } = response.authResponse;

          // إرسال البيانات إلى الباك اند
          sendToBackend(accessToken, userID);

          // جلب صفحات المستخدم
          fetchUserPages(accessToken);
        } else {
          console.error('❌ Login failed:', response);
        }
      },
      { scope: 'public_profile,email,pages_show_list,leads_retrieval' },
    );
  };

  // عند اختيار صفحة، جلب النماذج الخاصة بها
  const handlePageChange = (event) => {
    const pageId = event.target.value;
    setSelectedPage(pageId);
    setForms([]); // إعادة تعيين النماذج
    setSelectedForm(''); // إعادة تعيين النموذج المختار
    setLeads([]); // إعادة تعيين الـ Leads

    // البحث عن الـ Access Token الخاص بالصفحة المختارة
    const selected = pages.find((page) => page.id === pageId);
    if (selected) {
      console.log('🔄 Fetching forms for page:', pageId);
      fetchLeadForms(pageId, selected.access_token);
    }
  };

  // عند اختيار نموذج، جلب بيانات الـ Leads الخاصة به
  const handleFormChange = (event) => {
    const formId = event.target.value;
    setSelectedForm(formId);
    setLeads([]); // إعادة تعيين الـ Leads

    // البحث عن الـ Access Token الخاص بالصفحة المختارة
    const selected = pages.find((page) => page.id === selectedPage);
    if (selected) {
      console.log('🔄 Fetching leads for form:', formId);
      fetchLeads(formId, selected.access_token);
    }
  };

  return (
    <Container style={{ marginLeft: '150px', marginTop: '20px' }}>
      <div>
        <button
          onClick={handleLogin}
          style={{
            padding: '10px 20px',
            backgroundColor: '#1877f2',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginBottom: '20px',
          }}
        >
          Login with Facebook
        </button>

        {/* اختيار الصفحة */}
        {pages.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="page-select" style={{ display: 'block', marginBottom: '8px' }}>
              اختر صفحة:
            </label>
            <select
              id="page-select"
              onChange={handlePageChange}
              value={selectedPage}
              style={{
                padding: '8px',
                width: '300px',
                borderRadius: '4px',
                border: '1px solid #ddd',
              }}
            >
              <option value="">اختر صفحة</option>
              {pages.map((page) => (
                <option key={page.id} value={page.id}>
                  {page.name} ({page.id})
                </option>
              ))}
            </select>
          </div>
        )}

        {/* اختيار النموذج */}
        {forms.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="form-select" style={{ display: 'block', marginBottom: '8px' }}>
              اختر نموذج:
            </label>
            <select
              id="form-select"
              onChange={handleFormChange}
              value={selectedForm}
              disabled={!selectedPage}
              style={{
                padding: '8px',
                width: '300px',
                borderRadius: '4px',
                border: '1px solid #ddd',
              }}
            >
              <option value="">اختر نموذج</option>
              {forms.map((form) => (
                <option key={form.id} value={form.id}>
                  {form.name || `Form ${form.id}`}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* معلومات التتبع */}
        <div
          style={{
            backgroundColor: '#f8f9fa',
            padding: '15px',
            borderRadius: '5px',
            marginBottom: '20px',
            fontSize: '14px',
          }}
        >
          <strong>معلومات التتبع:</strong>
          <div>الصفحات: {pages.length}</div>
          <div>النماذج: {forms.length}</div>
          <div>الليادات: {leads.length}</div>
        </div>

        {/* عرض بيانات الـ Leads في جدول */}
        {leads.length > 0 ? (
          <div>
            <h3>بيانات الـ Leads ({leads.length})</h3>
            <table
              border="1"
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginTop: '10px',
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#f1f1f1' }}>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>الاسم</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>البريد الإلكتروني</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>رقم الهاتف</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>
                    بيانات كاملة (للت Debug)
                  </th>
                </tr>
              </thead>
              <tbody>
                {leads.map((lead, index) => {
                  const extractedData = extractLeadData(lead);
                  return (
                    <tr key={index}>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {extractedData.name}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {extractedData.email}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {extractedData.phone}
                      </td>
                      <td
                        style={{
                          padding: '10px',
                          border: '1px solid #ddd',
                          fontSize: '10px',
                          maxWidth: '200px',
                          wordBreak: 'break-all',
                        }}
                      >
                        {JSON.stringify(lead.field_data || 'No field_data')}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : selectedForm ? (
          <p style={{ color: '#666', fontStyle: 'italic' }}>
            لا توجد بيانات Leads متاحة لهذا النموذج.
          </p>
        ) : null}
      </div>
    </Container>
  );
};
